import * as React from "react";
import clsx from "clsx";
const Separator = (props) => {
  const { color, theme, weight, spacing, align, fullWidth, children, className, content, element: Element = "div", ...rest } = props;
  const classNames = clsx(
    "separator",
    {
      ["separator--color-".concat(color)]: !!color,
      ["separator--".concat(weight)]: !!weight,
      ["separator--".concat(spacing)]: !!spacing,
      ["separator--".concat(align)]: !!align,
      "separator--full-width": !!fullWidth,
      "separator--content": !!children
    },
    className
  );
  const TopElement = Element === "span" ? "span" : "div";
  if (children) {
    return /* @__PURE__ */ React.createElement(TopElement, { className: classNames, ...rest, "data-theme": theme }, Element === "hr" && /* @__PURE__ */ React.createElement(Element, { className: "sr-only" }), /* @__PURE__ */ React.createElement(TopElement, { className: "separator__content" }, children));
  }
  if (content) {
    return /* @__PURE__ */ React.createElement(TopElement, { className: classNames, ...rest, "data-theme": theme }, Element === "hr" && /* @__PURE__ */ React.createElement(Element, { className: "sr-only" }), content);
  }
  return /* @__PURE__ */ React.createElement(Element, { className: classNames, ...rest, "data-theme": theme });
};
export {
  Separator
};
